import { SearchOutlined } from '@ant-design/icons';
import { Col, DatePicker, Form, FormInstance, Select } from 'antd';
import { AxiosError } from 'axios';
import { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import GetDones from '~/@core/application/useCases/rfidReports/inventory/getDones';
import GetProducers from '~/@core/application/useCases/rfidReports/inventory/getProducers';
import DefaultPaginated from '~/@core/domain/@shared/DefaultPaginated';
import Done from '~/@core/domain/model/rfidReports/Done';
import Producer from '~/@core/domain/model/rfidReports/Producer';
import FormFilterDataModel, {
  MapFormToFilter
} from '~/@core/domain/ui/forms/FormFilterDataModel';
import DefaultRow from '~/components/bosons/DefaultRow';
import SearchButton from '~/components/Buttons/SearchButton';
import { globalContext } from '~/context/GlobalContext';
import useDoneStore from '~/zustand/rfidReports/inventory/done-state';
import useProducerStore from '~/zustand/rfidReports/inventory/producer-state';
import { SearchButtonDiv } from './FormFilterInventoryDone.styled';
import { PermissionNames } from '~/constants/permissionNames';

const { Option } = Select;

interface Props {
  form: FormInstance<FormFilterDataModel>;
}
export default function FormFilterInventoryDone(props: Props) {
  const { form } = props;
  const { t } = useTranslation();
  const { donePagination, addDones, handleDonePagination, setIsLoadingDone } =
    useDoneStore();
  const { producers, addProducers } = useProducerStore();

  const { handlePromiseUseCase, activeAlert } = useContext(globalContext);

  useEffect(() => {
    form.setFieldsValue({
      dtaFilter: []
    });
  }, [form]);

  useEffect(() => {
    const permissionName = PermissionNames.RfidReports.MenuInventory;
    const getProducers = new GetProducers(permissionName);

    handlePromiseUseCase<Producer[], AxiosError>(
      getProducers.execute(),
      (producerOut: any) => {
        addProducers(producerOut);
      },
      (error: any) => {
        activeAlert({
          message: JSON.stringify(
            error.response?.data
              ? error.response?.data
              : 'Houve um erro inesperado!'
          ),
          type: 'error',
          timeout: 5000
        });
      }
    );
  }, []);
  const onSubmitDone = useCallback(
    (formValues: FormFilterDataModel) => {
      const filterDone = MapFormToFilter.toFilter(formValues, {
        pageSize: donePagination.pageSize,
        pageNumber: donePagination.current
      });

      const getDones = new GetDones();
      setIsLoadingDone();

      handlePromiseUseCase<DefaultPaginated<Done[]>, AxiosError>(
        getDones.execute(filterDone),
        (donesOut: any) => {
          addDones(donesOut.results);
          handleDonePagination({
            ...donePagination,
            total: donesOut.totalCount
          });
          setIsLoadingDone();
        },
        (error: any) => {
          activeAlert({
            message: JSON.stringify(
              error.response?.data
                ? error.response?.data
                : 'Houve um erro inesperado!'
            ),
            type: 'error',
            timeout: 5000
          });
          setIsLoadingDone();
        }
      );
    },
    [
      donePagination,
      setIsLoadingDone,
      handlePromiseUseCase,
      addDones,
      handleDonePagination,
      activeAlert
    ]
  );

  return (
    <Form layout="vertical" form={form} onFinish={onSubmitDone}>
      <DefaultRow>
        <Col lg={6}>
          <Form.Item name="dtaFilter" label="Data de Consulta: ">
            <DatePicker.RangePicker
              format="DD/MM/YYYY"
              placeholder={['Início', 'Fim']}
            />
          </Form.Item>
        </Col>
        <Col lg={6}>
          <Form.Item
            name="producerFilter"
            label="Sítio: "
            rules={[{ required: true }]}
          >
            <Select allowClear placeholder="Selecione">
              {producers.map(producer => (
                <Option value={producer.account}>
                  {producer.account} - {producer.tradingName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col lg={3}>
          <SearchButtonDiv>
            <SearchButton
              id="done"
              htmlType="submit"
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => {}}
            />
          </SearchButtonDiv>
        </Col>
      </DefaultRow>
    </Form>
  );
}
